/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { DEACTIVATE_USER_ACCOUNT } from './graphql';

export function useDeactivateUserAccount() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [DeactivateUserAccount, { loading: apiLoading }] = useMutation(
    DEACTIVATE_USER_ACCOUNT,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function deactivateUserAccount(userId) {
    try {
      const res = await DeactivateUserAccount({
        variables: { userId },
      });
      if (res.data.deactivateUserAccount.code === 200) {
        setSuccessMessage('Conta desativada com sucesso!');
      } else {
        setErrorMessage(
          'Não foi possível desativar a conta, tente novamente mais tarde.',
        );
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível desativar a conta, tente novamente mais tarde.',
      );
    }
  }

  return {
    deactivateUserAccount,
    loading: isLoading,
  };
}
